// extracted by mini-css-extract-plugin
export default {"container":"RecruitmentPage_container__7JuZM"};